/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Developer_Client_IdInputs */



/**
* | output |
* | --- |
* | "Client ID:" |
*
* @param {Developer_Client_IdInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const developer_client_id = /** @type {((inputs?: Developer_Client_IdInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Developer_Client_IdInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ID client :")
	if (locale === "es") return /** @type {LocalizedString} */ ("ID de cliente:")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Client ID:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Client ID:")
	return /** @type {LocalizedString} */ ("Client ID:")
});